/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      first_name
      last_name
      email
      phone_number
      imageUri
      status
      pause_notifications
      qotd
      bible
      french
      spanish
      active_account
      role
      chat_group_user {
        items {
          id
          user_id
          is_vip
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChatGroupUser = /* GraphQL */ `
  query GetChatGroupUser($id: ID!) {
    getChatGroupUser(id: $id) {
      id
      user_id
      is_vip
      chat_group_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      chat_group {
        id
        group_title
        pause_notifications
        created_by
        vip_user_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group_users {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        messages {
          items {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        last_message_id
        last_message {
          id
          createdAt
          content
          user_id
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listChatGroupUsers = /* GraphQL */ `
  query ListChatGroupUsers(
    $filter: ModelChatGroupUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatGroupUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        is_vip
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChatGroup = /* GraphQL */ `
  query GetChatGroup($id: ID!) {
    getChatGroup(id: $id) {
      id
      group_title
      pause_notifications
      created_by
      vip_user_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      chat_group_users {
        items {
          id
          user_id
          is_vip
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          createdAt
          content
          user_id
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      last_message_id
      last_message {
        id
        createdAt
        content
        user_id
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listChatGroups = /* GraphQL */ `
  query ListChatGroups(
    $filter: ModelChatGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group_title
        pause_notifications
        created_by
        vip_user_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group_users {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        messages {
          items {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        last_message_id
        last_message {
          id
          createdAt
          content
          user_id
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      createdAt
      content
      user_id
      chat_group_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      chat_group {
        id
        group_title
        pause_notifications
        created_by
        vip_user_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group_users {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        messages {
          items {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        last_message_id
        last_message {
          id
          createdAt
          content
          user_id
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        content
        user_id
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getScheduledMessage = /* GraphQL */ `
  query GetScheduledMessage($id: ID!) {
    getScheduledMessage(id: $id) {
      id
      createdAt
      content
      message_schedule
      messageScheduleTime
      messageScheduleTimeMin
      messageScheduleTimeMon
      messageScheduleTimeDay
      messageScheduleTimeDayWK
      messageScheduleTimeYr
      messageStream
      followup_message
      followup_schedule
      followMessageTime
      user_id
      chat_group_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      chat_group {
        id
        group_title
        pause_notifications
        created_by
        vip_user_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group_users {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        messages {
          items {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        last_message_id
        last_message {
          id
          createdAt
          content
          user_id
          chat_group_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group {
            id
            group_title
            pause_notifications
            created_by
            vip_user_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group_users {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            messages {
              items {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              nextToken
            }
            last_message_id
            last_message {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          updatedAt
        }
        createdAt
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listScheduledMessages = /* GraphQL */ `
  query ListScheduledMessages(
    $filter: ModelScheduledMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScheduledMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        content
        message_schedule
        messageScheduleTime
        messageScheduleTimeMin
        messageScheduleTimeMon
        messageScheduleTimeDay
        messageScheduleTimeDayWK
        messageScheduleTimeYr
        messageStream
        followup_message
        followup_schedule
        followMessageTime
        user_id
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDailyMessage = /* GraphQL */ `
  query GetDailyMessage($id: ID!) {
    getDailyMessage(id: $id) {
      id
      createdAt
      scheduled_date
      content
      author
      author_id
      message_type
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      updatedAt
    }
  }
`;
export const listDailyMessages = /* GraphQL */ `
  query ListDailyMessages(
    $filter: ModelDailyMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        scheduled_date
        content
        author
        author_id
        message_type
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFaq = /* GraphQL */ `
  query GetFaq($id: ID!) {
    getFAQ(id: $id) {
      id
      title
      content
      author_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFaQs = /* GraphQL */ `
  query ListFaQs(
    $filter: ModelFAQFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFAQs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        content
        author_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSupport = /* GraphQL */ `
  query GetSupport($id: ID!) {
    getSupport(id: $id) {
      id
      name
      email
      message
      status
      author_id
      user {
        id
        first_name
        last_name
        email
        phone_number
        imageUri
        status
        pause_notifications
        qotd
        bible
        french
        spanish
        active_account
        role
        chat_group_user {
          items {
            id
            user_id
            is_vip
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listSupports = /* GraphQL */ `
  query ListSupports(
    $filter: ModelSupportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        message
        status
        author_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const messagesByChatGroup = /* GraphQL */ `
  query MessagesByChatGroup(
    $chat_group_id: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByChatGroup(
      chat_group_id: $chat_group_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        content
        user_id
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const scheduledMessagesByChatGroup = /* GraphQL */ `
  query ScheduledMessagesByChatGroup(
    $chat_group_id: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledMessagesByChatGroup(
      chat_group_id: $chat_group_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        content
        message_schedule
        messageScheduleTime
        messageScheduleTimeMin
        messageScheduleTimeMon
        messageScheduleTimeDay
        messageScheduleTimeDayWK
        messageScheduleTimeYr
        messageStream
        followup_message
        followup_schedule
        followMessageTime
        user_id
        chat_group_id
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        chat_group {
          id
          group_title
          pause_notifications
          created_by
          vip_user_id
          user {
            id
            first_name
            last_name
            email
            phone_number
            imageUri
            status
            pause_notifications
            qotd
            bible
            french
            spanish
            active_account
            role
            chat_group_user {
              items {
                id
                user_id
                is_vip
                chat_group_id
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          chat_group_users {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          messages {
            items {
              id
              createdAt
              content
              user_id
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          last_message_id
          last_message {
            id
            createdAt
            content
            user_id
            chat_group_id
            user {
              id
              first_name
              last_name
              email
              phone_number
              imageUri
              status
              pause_notifications
              qotd
              bible
              french
              spanish
              active_account
              role
              chat_group_user {
                nextToken
              }
              createdAt
              updatedAt
            }
            chat_group {
              id
              group_title
              pause_notifications
              created_by
              vip_user_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group_users {
                nextToken
              }
              messages {
                nextToken
              }
              last_message_id
              last_message {
                id
                createdAt
                content
                user_id
                chat_group_id
                updatedAt
              }
              createdAt
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const dailyMessagesByType = /* GraphQL */ `
  query DailyMessagesByType(
    $message_type: MessageType
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyMessagesByType(
      message_type: $message_type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        scheduled_date
        content
        author
        author_id
        message_type
        user {
          id
          first_name
          last_name
          email
          phone_number
          imageUri
          status
          pause_notifications
          qotd
          bible
          french
          spanish
          active_account
          role
          chat_group_user {
            items {
              id
              user_id
              is_vip
              chat_group_id
              user {
                id
                first_name
                last_name
                email
                phone_number
                imageUri
                status
                pause_notifications
                qotd
                bible
                french
                spanish
                active_account
                role
                createdAt
                updatedAt
              }
              chat_group {
                id
                group_title
                pause_notifications
                created_by
                vip_user_id
                last_message_id
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;
